import React from 'react';
import VideoPage from "./video_page";
import Navbar from "../components/Navbar";
import axios from "axios";
import LelangList from "../components/LelangList";
import LelangListFinish from "../components/LelangListFinish";
import FlickitySlider from "../components/FlickitySlider";
import Footer from "../components/Footer";
import { pageFilter, getArtistCookie } from "../data/page_data";
import Loading from "../components/loading";
import { utilLoopHelper } from "../utils";
import CssLoader from '../components/CssLoader';
import { navigate } from '@reach/router';
import * as ReactGA from "react-ga";

class LelangDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.pageData = pageFilter(this.props.artist, '');
    this.state = {}
  }

  componentDidMount() {
    axios.get('/w/api/' + this.pageData.artist.id + '/lelang-detail?id=' + this.props.id,{headers:{
      PortalAuth: getArtistCookie(this.props.artist)
    }})
      .then(response => {
        var respData = response.data;
        this.setState(state => ({ data: respData }));
      }).catch(error =>{
      document.location.href = "join";
      });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    //if(!this.state.data) return <></>;
    return <>
      <CssLoader css={this.pageData.artist.css} />
      <Navbar back='../../home' data={this.pageData} title="LELANG" />
      {!this.state.data ? <Loading /> :
        <>
          <div className="lelang-detail-page">
            <div className="t-slider">
              <div className="t-slider-card">
                <div className="lelang-inner">
                  <div className="lelang-title">{this.state.data.title}</div>
                  <div class="ldp-slider">
                    <FlickitySlider options={{
                      "freeScroll": true,
                      "contain": true,
                      "prevNextButtons": false,
                      "pageDots": false
                    }}>
                      {this.state.data.photos.map((item, index) => {
                        return <div className="carousel-cell">
                          <div className="lelang-img">
                            <img
                              src={item} />
                          </div>
                        </div>
                      })}

<div className="div-last-slider"></div>
                    </FlickitySlider>
                  </div>
                  <div className="lelang-last-bid">{this.state.data.last_bid}</div>
                  <div className="lelang-result">{this.state.data.last_bid}</div>
                  <div className="lelang-input">
                    <input type="text" className="form-control" placeholder="2550000" />
                    <button className="btn btn-tawar">TAWAR</button>
                  </div>
                  <div className="lelang-note">*Minimal Rp {this.state.data.bid_increment} atau kelipatannya</div>
                  <div className="lelang-detail">
                    <div><img src="http://resources.triyakom.com/mini_portal/clock.svg" /><span>{this.state.data.time_left}</span>
                    </div>
                    <div><img src="http://resources.triyakom.com/mini_portal/check.png" /><span>{this.state.data.bid_count} Tawaran</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lelang-detail-desc">
              <h4>Deskripsi Barang</h4>
              <div dangerouslySetInnerHTML={{ __html: this.state.data.description }} />
            </div>
          </div>
          {this.state.data.other &&
            <div className="content lelang">
              <div className="container">
                <h4>Tawar sekarang dari {this.pageData.artist.nick}</h4>
                <ul>
                  {
                    this.state.data.other.items.map((item, index) => {
                      return <LelangList data={item} />
                    })
                  }
                </ul>
              </div>
            </div>
          }
        </>
      }
      <Footer />
    </>;
  }
}

export default LelangDetailPage;
